import { auth } from "../repositories/";

export default {
  authSignIn: async (query: any, callback: (data?: any, err?: any) => void) => {
    try {
      const rs = await auth.authSignIn(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  authSignUp: async (query: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await auth.authSignUp(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  authConfirmOTP: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await auth.authConfirmOTP(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  authResendOTP: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await auth.authResendOTP(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  authForgotPassword: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await auth.authForgotPassword(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  authSignOut: async (callback: (data: any, err: any) => void) => {
    try {
      const rs = await auth.authSignOut();
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
};
